var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 bg-white flex flex-col justify-between"},[(_vm.$route.meta && !_vm.$route.meta.hideNavbar)?_c('myc-header'):_vm._e(),_vm._t("default"),(_vm.$route.meta && !_vm.$route.meta.hideFooter)?_c('myc-footer'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }